import { render } from "./BaseAlert.vue?vue&type=template&id=0c93fdca&ts=true"
import script from "./BaseAlert.vue?vue&type=script&lang=ts"
export * from "./BaseAlert.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__